import { useRouteError } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import Navigation from 'Components/Navigation'

export default function ErrorPage() {
	const error = useRouteError()
	console.error(error)

	return (
		<>
			<Navigation />
			<Box display="flex" justifyContent="center" alignItems="center" py={12}>
				<Box align="center">
					<Typography variant="h1">Oops!</Typography>
					<Box mt={8} mb={4}>
						<Typography>Sorry, an unexpected error has occurred.</Typography>
					</Box>
					<Typography color="red">
						<i>{error.statusText || error.message}</i>
					</Typography>
				</Box>
			</Box>
		</>
	)
}
